
import { useState } from "react";
import { motion } from "framer-motion";
import PricingHeader from "./PricingHeader";
import PricingCards from "./PricingCards";

const PricingSection = () => {
  const [billingPeriod, setBillingPeriod] = useState<"monthly" | "yearly">("monthly");

  const toggleBillingPeriod = () => {
    setBillingPeriod(billingPeriod === "monthly" ? "yearly" : "monthly");
  };

  return (
    <div className="px-4 sm:px-6 py-8 sm:py-16 overflow-hidden">
      <motion.div
        className="text-center mb-8 sm:mb-16"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <PricingHeader 
          billingPeriod={billingPeriod} 
          toggleBillingPeriod={toggleBillingPeriod} 
        />
      </motion.div>

      <PricingCards billingPeriod={billingPeriod} />
    </div>
  );
};

export default PricingSection;
